/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Tut_Meja_GInputs */

const en_tut_meja_g = /** @type {(inputs: Tut_Meja_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`A private desk creates a quiet zone around you, and lets you hold a small call with people you choose without opening a meeting room.`)
};

const id_tut_meja_g = /** @type {(inputs: Tut_Meja_GInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Meja privat membuat zona tenang di sekitar meja Anda, dan memungkinkan panggilan kecil dengan rekan yang Anda pilih tanpa membuka ruang rapat.`)
};

/**
* | output |
* | --- |
* | "A private desk creates a quiet zone around you, and lets you hold a small call with people you choose without opening a meeting room." |
*
* @param {Tut_Meja_GInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const tut_meja_g = /** @type {((inputs?: Tut_Meja_GInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Tut_Meja_GInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_tut_meja_g(inputs)
	return en_tut_meja_g(inputs)
});